import React from "react";
import {Button, TextField} from "@material-ui/core";
import {TimePicker} from "antd";
import UrlArgsBundle from "../../../core/url_args_bundle";
import {ACTIVITY_TAG, API_KEY, FRAGMENT_TAG} from "../../../utils/constants";
import axios from "axios";
import {createApiServerRoute} from "../../../models/network/api_client";
import {withRouter} from "react-router-dom";

class AddStarlineGameFragment extends React.Component {

    urlArgsBundle = new UrlArgsBundle();
    getFragment = (fragmentTag) => {
        this.urlArgsBundle.setActivityTag(ACTIVITY_TAG.MAIN).setFragmentTag(fragmentTag);
        this.props.history.push(this.urlArgsBundle.getArgsAsUrlParams())
    }

    constructor(props) {
        super(props);
        this.state = {
            open_time_hour: "7",
            open_time_minute: "15",
            open_time_type: "AM",
            sort_position: ""
        }
    }

    addGame = () => {
        console.log("function called")
        if (this.state.sort_position !== "") {
            const params = new URLSearchParams();
            console.log("condition true")

            params.append("__api_key__", API_KEY)
            params.append("open_time_hour", this.state.open_time_hour)
            params.append("open_time_minute", this.state.open_time_minute)
            params.append("open_time_am_or_pm", this.state.open_time_type)
            params.append("sort_position", this.state.sort_position)

            const config = {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                }
            };

            axios.post(createApiServerRoute('create_starline_game.php'), params, config)
                .then(res => {
                    console.log("result fetched")

                    console.log(res)
                    if (res.data.state === 'OK') {
                        console.log("result OK")
                        this.getFragment(FRAGMENT_TAG.STARLINE_GAME)
                    } else {
                        console.log("result NOT OK")
                    }
                })
        }
        return null
    }


    render() {

        return <div className={"py-36 ba-gray-200 grid place-items-center"}>
            <div className="form-card w-96 bg-white py-6 px-10 rounded-2xl shadow-2xl flex flex-col gap-6">
                <h1 className={"text-center text-indigo-800 text-2xl pb-3"}>Add Starline Game</h1>
                <TimePicker
                    className={"h-14 rounded-md"}
                    format={'h:mm a'}
                    placeholder={'Open Time'}
                    onChange={(time, timeString) => {
                        let t = timeString.split(' ')

                        this.setState({
                            ...this.state,
                            open_time_hour: t[0].split(':')[0],
                            open_time_minute: t[0].split(':')[1],
                            open_time_type: t[1]
                        })
                    }}
                />
                <TextField fullWidth id="standard-basic" value={this.state.sort_position}
                           label="Sort Position" variant="outlined"
                           inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} onChange={(e) => {
                    const re = /[0-9]+/g;
                    if (e.target.value === '' || re.test(e.target.value)) {
                        this.setState({...this.state , sort_position : e.target.value})
                    }}} />
                <Button className={"h-12 rounded-md"} variant="contained" color="primary" onClick={this.addGame}>Add</Button>
            </div>
        </div>
    }
}

export default withRouter(AddStarlineGameFragment)